import React from  'react';
import LoadingComponent from '../commonComponents/LoadingComponent'
import { Link } from 'react-router-dom';
import FeedbackComponent from '../commonComponents/FeedbackComponent'
import TopInfo from '../commonComponents/TopInfo';

var i = 0;
var hStyle = {
    margin: '5% auto',
    textAlign: 'center'
}
var Style = {
    height: screen.height - 300 + "px",
    overflow: 'hidden',
    width: 'auto'
};
var myStyle = {
    height: screen.height - 300 + "px",
    overflow: 'hidden',
    width: 'auto',
    position: 'relative'
};
var chartStyle = {
    height: '350px',
    width: '100%',
};
var moduleStyle = {
    width: '300px',
    margin: '20px auto'
};
var AlfredStyle = {
    fontSize: '1.2em',
    overflow: 'hidden',
    background: 'white',
    border: '1px solid #b7ccc8',
    minHeight: '660px',
    marginBottom: '20px',
};

var alfredMiddleStyle = { margin: '29% 5px 12px 8px' };
var alfredMiddleStyleHr = { margin: '13px 14px 12px -61px', width: '123%' };
var alfredBottomStyleHr = { margin: '13px 0px 12px -61px', width: '123%' };

class TextMessage extends React.Component{
    constructor(props) {
        super(props)
        this.state= {
            selected: null,
            data: this.props.data,
            val: 6
        };
    }
    handleChangeEvent=(e, type)=>{
        this.setState({
            chartSelected: e.index
        });
    }
    showMore=()=>{
        chartSelected = this.state.chartSelected == null || this.state.chartSelected == '' && this.state.chartSelected != 0 ? 0 : this.state.chartSelected;
        chartData = this.state.data.charts;
        this.setState({
            val: Object.keys(chartData).length
        })
    }
    render() {
        var showMore, colorAdd;
        if (typeof this.state.data == 'object') {
            if (this.state.data.intent == null) {
                return (<LoadingComponent />);
            }
            var popular = ['Table', 'Column', 'Pie','Donut 3D',"Block"];
            var chartSelected = this.state.chartSelected == null || this.state.chartSelected == '' && this.state.chartSelected != 0 ? 0 : this.state.chartSelected;
            var chartData = this.state.data.chart_array.All;
            var intentData = this.state.data.intent;
            var location = this.state.data.location;
            var handleChangeEvent = this.handleChangeEvent;
            var handleChange = this.props.handleChange;
            var popularIndex = 0;
            return (<div className="box col-md-12 pd-l-0">
                <div>
                    <span>
                        {/* <a href={null} style={{ textDecoration: 'none' }}>Popular Charts</a> */}
                        <h6 class="mg-b-0">Popular Charts</h6>
                    </span>
                </div>

                <div className='row mg-y-10'>
                    {Object.keys(chartData).map(function (objectName, index) {
                        if (jQuery.inArray(objectName, popular) > -1) {
                            popularIndex = popularIndex + 1;
                            return (<InnerElements key={"innerElement_popular_" + index} id={'popular' + popularIndex} data={chartData[objectName]} />);
                        }
                    })}
                </div>
                <div>
                    <span>
                        {/* <a href={null} style={{ textDecoration: 'none' }}>All Charts</a> */}
                        <h6 class="mg-b-0">All Charts</h6>
                    </span>
                </div>
                {/* <div className="box col-md-12"> */}
                    <div className='row mg-y-10'>
                        {Object.keys(chartData).map(function (objectName, index) {
                            return (<InnerElements key={"innerElement"+index} id={'chartdiv' + index} data={chartData[objectName]} location={location} />);
                        })}
                    </div>
                {/* </div> */}
            </div>
            );
        }
        else return (<span>{this.state.data}</span>);
    }
};

class InnerElements extends React.Component{
    constructor(props){
        super(props)
        
    }
    handleRedirect=(value, location)=> {
        var type = 'Chart';
        var path = null;
        switch(value){
            case "Block":
            case "Summary":
                path = "/summary?nav=new";
                break;
            case "Table":
                path = "/report?nav=new";
                break;
            default:
                path = `/chart/chartData?chartCat=${value}&nav=new`;
                break
        }
        return path;
    }
    render() {
        let chartName = this.props.data.name == 'Block' ? 'Summary' : this.props.data.name
        let redirectPath = this.handleRedirect(chartName, this.props.location);
        return (
            <div className="col-6 col-sm-4 col-md-2 mg-b-5" key={this.props.id} id={this.props.id}  style={{textAlign:"center"}}>
                <Link to={redirectPath} id={chartName.replace(" ","_").toLowerCase()}>
                    <img className='icon-intent' src={this.props.data.img} /><br />
                    <div className='mg-10'>{chartName}</div>
                </Link>
            </div>
        );
    }
};

class ChartHomePage extends React.Component{
    constructor (props) {
        super(props)
        this.state={
            data: props.data,
            query: ''
        }
    }    
    componentWillMount() {
    }
    QueryChange=(e)=>{
        this.setState({
            question: e
        })
    }
    render() {
        return (
            <TextMessage data={this.state.data} handleChange={this.QueryChange} />
        );
    }
};

var questions = {
    Intent: null,
    chart: null
};
var initialData = {
    mainData: [{
        data: questions,
        type: 'text'
    }]
};
var metric = null;
var li = {
    tabName: [{ name: 'Ecommerce', val: 1 }]
};
export default ChartHomePage  
